// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiscalYearSelect-module_fiscal_input_simple___ugE input {
  box-shadow: none;
  padding-right: 4px;
  padding-left: 6px;
  margin: 1px 0;
}

.FiscalYearSelect-module_fiscal_input_simple___ugE input:focus {
  box-shadow: none;
}

.FiscalYearSelect-module_fiscal_input_EC2dy input {
  padding-right: 0;
  padding-left: 35px;
}

.FiscalYearSelect-module_fiscal_input_auto_margin_ZksPP input {
  padding-right: 0;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/BOSFilterSelect/FiscalYearSelect.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".fiscal_input_simple input {\n  box-shadow: none;\n  padding-right: 4px;\n  padding-left: 6px;\n  margin: 1px 0;\n}\n\n.fiscal_input_simple input:focus {\n  box-shadow: none;\n}\n\n.fiscal_input input {\n  padding-right: 0;\n  padding-left: 35px;\n}\n\n.fiscal_input_auto_margin input {\n  padding-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fiscal_input_simple": `FiscalYearSelect-module_fiscal_input_simple___ugE`,
	"fiscal_input": `FiscalYearSelect-module_fiscal_input_EC2dy`,
	"fiscal_input_auto_margin": `FiscalYearSelect-module_fiscal_input_auto_margin_ZksPP`
};
export default ___CSS_LOADER_EXPORT___;
